module.exports = __webpack_public_path__ + "img/fondo-wordpress.d5fcda64.jpeg";